<template>
    <v-navigation-drawer
        v-model="drawer"
        :disable-resize-watcher="true"
        class="rounded-s-xl"
        location="right"
        width="320"
    >
        <!-- Top content -->
        <div class="d-flex flex-column h-100">
            <div class="d-flex justify-space-between  mt-2 mr-2">
                <v-img
                    :class="{
                        'cursor-pointer': $route.name !== 'Home'
                    }"
                    @click="navigate_home"
                    class="ml-4"
                    max-width="56px"
                    src="@/assets/logo_black.png"
                />

                <v-btn
                    @click="drawer = false"
                    icon="mdi-close"
                    size="small"
                    variant="flat"
                />
            </div>
            <v-list
                class="mt-1"
                nav
            >
                <template
                    v-for="item in items"
                    :key="item.value"
                >
                    <v-divider
                        v-if="item.divider_before"
                        class="my-2"
                    />
                    <v-list-item
                        :prepend-icon="item.icon"
                        :title="translate(item.title)"
                        :to="item.to"
                        @click="handle_click(item)"
                        class="align-center"
                    >
                        <template
                            v-if="item.inline_badge_count"
                            #append
                        >
                            <v-badge
                                :content="item.inline_badge_count"
                                color="red_dark"
                                max="9"
                                inline
                            />
                        </template>
                    </v-list-item>
                </template>
                <v-divider class="my-2" />
                <v-list-item
                    :title="translate('common.logout')"
                    @click="logout"
                    prepend-icon="mdi-logout"
                />
            </v-list>

            <!-- Push content below to the bottom -->
            <div class="flex-grow-1"></div>
            <!-- Bottom content -->
            <Token
                v-if="$vuetify.display.mobile"
                @close="drawer = false"
                class="pa-2 mb-2"
                label="common.signed_in_as"
                style="width: 100%"
            />
        </div>


    </v-navigation-drawer>
    <v-app-bar
        v-if="display"
        color="primary"
        density="comfortable"
    >
        <v-app-bar-title>
            <v-img
                @click="navigate_home"
                alt="Mitt Amili"
                class="cursor-pointer"
                max-width="100px"
                src="@/assets/mitt_amili_logo.svg"
            />
        </v-app-bar-title>

        <v-chip
            v-if="token_json.signed_in_by_u_id"
            color="orange"
            text-color="white"
            variant="tonal"
        >
            {{ $t('common.as_x', { x: token_json.u_name }) }}
            <span
                v-if="token_json.readonly"
                class="ml-1"
            >
                ({{ $t('common.read') }})
            </span>
        </v-chip>

        <Token
            v-if="!$vuetify.display.mobile"
            label="common.signed_in_as"
        />

        <Language />


        <v-app-bar-nav-icon
            v-if="!drawer"
            @click="drawer = true"
        >
            <v-badge
                :content="unread_tickets"
                :model-value="unread_tickets > 0"
                color="red_dark"
                max="9"
            >
                <v-icon
                    icon="mdi-menu"
                />

            </v-badge>

        </v-app-bar-nav-icon>


    </v-app-bar>
</template>

<script>
import { locales_mixin } from '@old/mixins/locales_mixin'
import { user_mixin } from '@old/mixins/user_mixin'
import Language from '@old/components/navigation/Language.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import Token from '@old/components/navigation/Token.vue'

export default {
    name: 'Navigation',
    props: {},
    mixins: [locales_mixin, user_mixin],
    components: { Token, Language },
    data() {
        return {
            drawer: false,
        }
    },
    computed: {
        items() {
            const items = [
                {
                    title: 'common.cases',
                    icon: 'mdi-credit-card-outline',
                    value: 'home',
                    to: '/',
                },
                {
                    title: 'common.my_profile',
                    icon: 'mdi-account-circle-outline',
                    value: 'my_profile',
                    to: '/profile',
                },
                {
                    title: 'common.support',
                    icon: 'mdi-chat-question-outline',
                    value: 'support',
                    to: '/support',
                    inline_badge_count: this.unread_tickets,
                },
                {
                    title: 'common.debt_summary',
                    icon: 'mdi-file-pdf-box',
                    value: 'debt_summary',
                    to: '/summary',
                },
                {
                    title: 'common.about_site',
                    icon: 'mdi-text-box-outline',
                    value: 'about_site',
                    to: '/om-webbplatsen',
                    divider_before: true,
                },
            ]

            return items
        },
        display() {
            return this.$route.name !== 'Authenticate'
        },
        ...mapState(['unread_tickets']),
        ...mapGetters(['token_json']),
    },
    watch: {},
    methods: {
        handle_click(item) {
            if (item.to) return
            this.drawer = false
            item.action()
        },
        navigate_home() {
            this.drawer = false
            if (this.$route.name !== 'Home') {
                this.$router.push('/')
            }
        },
        logout() {
            this.drawer = false
            this.logout_user()
        },
        ...mapActions(['set_state_property']),
    },
    beforeCreate() {
    },
    created() {
    },
    beforeMount() {
    },
    mounted() {
    },
    beforeUpdate() {
    },
    updated() {
    },
    beforeUnmount() {
    },
}
</script>

<style scoped lang="sass"></style>
